import { showBtnLoading, stopBtnLoading } from './loading'
import { showCommonMessage } from './popup'

export function purgeAjax(e) {
    e.preventDefault();

    const $btn = jQuery(e.currentTarget);
    showBtnLoading($btn, 'Purging...');
    const post_id = rabbitloader_local_vars.post_id ? rabbitloader_local_vars.post_id : '';

    const formData = new FormData();
    formData.append('action', "rabbitloader_ajax_purge");//rabbitloader_ajax_purge
    formData.append('post_id', post_id);
    formData.append('rl_nonce', rabbitloader_local_vars.rl_nonce);
    fetch(rabbitloader_local_vars.admin_ajax, {//here we can not access the global "ajaxurl" because it is not available for single purge pages
        'method': 'POST',
        'body': formData
    }).then(res => res.json())
        .then(json => {
            //console.log(json);
            if (json && json.result) {
                if (post_id) {
                    showCommonMessage(`Purge completed for page - ${document.title}`);
                } else {
                    showCommonMessage(`Purge completed`);
                }
            } else {
                showCommonMessage('Purge failed. Please reload the page and try again.');
            }
            stopBtnLoading($btn);
        });
}